module.exports = __webpack_public_path__ + "img/5c637c0.png";